
function notifyClientPage (data) {
    console.log('AppClientStore.notifyClientPage() ', data);
    if (window.parent) {
        window.parent.postMessage(data, '*');
    }
}

export default notifyClientPage;